import { Tool } from './base'

/**
 * Tools below have no query rendering implementation — they appear in the user-facing
 * supported-tools lists (Settings → Environment, custom hunt package dropdowns) but don't
 * participate in RTD/tuning. Subclasses are kept here so the central tool registry remains
 * the single source of truth for tool metadata (kind, customMapping, etc.).
 */

// Elastic Signal: Elasticsearch-based detection rules. Behaves like a SIEM for categorization
// and supports user-defined custom field mappings.
export class ElasticSignalTool extends Tool {
  public readonly toolName = 'Elastic Signal'
  public readonly toolKind = 'siem' as const
  public override readonly customMapping = true
}

// CarbonBlack Cloud LiveQuery: osquery-based endpoint queries (EDR-class).
export class CarbonBlackCloudLiveQueryTool extends Tool {
  public readonly toolName = 'CarbonBlack Cloud - LiveQuery'
  public readonly toolKind = 'edr' as const
}

// Snort/Yara are signature/rule formats, not query languages — they surface in the
// supported-tools UI for environment configuration but never reach RTD rendering.
export class SnortTool extends Tool {
  public readonly toolName = 'Snort'
  public readonly toolKind = 'misc' as const
}

export class YaraTool extends Tool {
  public readonly toolName = 'Yara'
  public readonly toolKind = 'misc' as const
}
